import React from "react";
import mainLogo from "../image/TarushiWN.png";
import logo1 from "../image/tarushi.png";
import "./Footer.css";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      {/* Main Logo with Subheading */}
      <div className="footer-logo-container">
        <img src={mainLogo} alt="INVIICTUSS AI" className="main-logo" />
        <p className="footer-tagline">
          We're passionate about empowering individuals and teams to become
          software development superstars.
        </p>
      </div>

      <div className="background-logo-container">
        <img src={logo1} alt="Background Logo" className="background-logo" />
      </div>

      {/* Footer Content */}
      <div className="footer-container">
        {/* Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/about-us">About Us</a>
            </li>
            <li>
              <a href="/services">Services</a>
            </li>
            <li>
              <a href="/contact-us">Contact</a>
            </li>
          </ul>
        </div>

        {/* Services Section */}
        <div className="footer-section">
          <h3>Services</h3>
          <ul>
            <li>
              <a href="#">Quality Assurance</a>
            </li>
            <li>
              <a href="#">NABH Accreditation</a>
            </li>
            <li>
              <a href="#">HMIS</a>
            </li>
            <li>
              <a href="#">Due Diligence</a>
            </li>
            <li>
              <a href="#">Clinical Data Management</a>
            </li>
            <li>
              <a href="#">Medical Value Travel</a>
            </li>
            <li>
              <a href="#">Biomedical Equipment</a>
            </li>
            <li>
              <a href="#">HR Recruitment</a>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>Email: info@tarushihealthcare.com</p>
          <p>Phone: +91 9941332698</p>
          <p>Address: Madhapur Hyderabad, Telangana 500081</p>
        </div>

        {/* Social Media Icons */}
        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <a href="#">
              <FaFacebookF />
            </a>
            <a href="#">
              <FaTwitter />
            </a>
            <a href="#">
              <FaInstagram />
            </a>
            <a href="#">
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="footer-bottom">
        <p>
          &copy; 2024 Tharushi Healthcare Private Limited. All Rights Reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
